import Box from '@/components/UI/box/Box';
import ModalRateItem from './modalRateItem/ModalRateItem';
import { IconNames } from '@/components/UI/Types';
import Icon from '@/components/UI/icon/Icon';
import { useDispatch, useSelector } from 'react-redux';
import { getDaysPassed } from '@/helpers/jalaliDate';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useEffect, useState } from 'react';
import { fetchProductReviews } from '@/redux/store/actions/product';
import useDevice from '@/hooks/useDevice';
import Styles from './ReviewsModal.module.scss';
import Typography from '@/components/UI/typography/Typography';
import Spinner from '@/components/UI/spinner/Spinner';
import { ProductItemTypes } from '@/components/houses/_types/productItem.types';
import ReviewCard from '@/components/houses/_reusable/houseInfo/reviews/reusable/reviewCard/ReviewCard';
import ReviewCardSkeleton from '@/components/houses/_reusable/houseInfo/reviews/reusable/reviewCardSkeleton/ReviewCardSkeleton';
import Skeleton from '@/components/UI/skeleton/Skeleton';
interface ReviewsModalType {
  id: number;
  data: ProductItemTypes;
  handleClose: () => void;
  reviewIndex?: number;
  handleReviewIndex?: () => void;
  open: boolean;
}
const Suggest = {
  1: 'dislike',
  2: 'no-idea',
  3: 'like'
};
const ReviewsModal = ({
  id,
  data,
  handleClose,
  reviewIndex,
  handleReviewIndex,
  open
}: ReviewsModalType) => {
  const [page, setPage] = useState<number>(1);
  const {
    productReducer
  } = useSelector(state => state);
  const {
    isMobile
  } = useDevice();
  const dispatch = useDispatch();
  const reviews = productReducer?.data?.productReviewsList?.data?.reviews;
  const totalReviews = productReducer?.data?.productReviewsList?.data?.total;
  const loading = productReducer?.data?.productReviewsList?.loading;
  useEffect(() => {
    if (reviewIndex) {
      document.getElementById('review_item_' + reviewIndex)?.scrollIntoView({
        behavior: 'smooth'
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reviews, reviewIndex]);
  useEffect(() => {
    if (open) dispatch(fetchProductReviews(id as number, page));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  const rateItems = [{
    icon: 'star-1',
    title: 'امتیاز اقامتگاه',
    rate: data?.rates?.rank
  }, {
    icon: 'broom',
    title: 'نظافت',
    rate: data?.rates?.cleanliness
  }, {
    icon: 'clipboard-tick',
    title: 'تطابق اطلاعات',
    rate: data?.rates?.accuracy
  }, {
    icon: 'wallet-money',
    title: 'ارزش قیمت',
    rate: data?.rates?.value
  }, {
    icon: 'user-square',
    title: 'نحوه میزبانی',
    rate: data?.rates?.host
  }, {
    icon: 'map',
    title: 'مسیر و دسترسی',
    rate: data?.rates?.accessibility
  }];
  return <Box className={Styles['reviews-modal']} data-sentry-element="Box" data-sentry-component="ReviewsModal" data-sentry-source-file="ReviewsModal.tsx">
      <Box className={Styles['review-modal-header']} onClick={() => {
      handleClose();
      handleReviewIndex && handleReviewIndex();
    }} data-sentry-element="Box" data-sentry-source-file="ReviewsModal.tsx">
        <Box className={Styles['close-button']} data-sentry-element="Box" data-sentry-source-file="ReviewsModal.tsx">
          <Icon name={isMobile ? 'arrow-right-1' : 'close'} type="highEmphasis" size="large" data-sentry-element="Icon" data-sentry-source-file="ReviewsModal.tsx" />
        </Box>
        <Typography component="span" variant="bodyL_Bold" data-sentry-element="Typography" data-sentry-source-file="ReviewsModal.tsx">
          امتیاز و نظرات کاربران
        </Typography>
      </Box>
      <Box className={Styles['review-modal-main-container']} data-sentry-element="Box" data-sentry-source-file="ReviewsModal.tsx">
        {!isMobile && <Box className={Styles['reviews-rate-items']}>
            {rateItems.map(({
          icon,
          title,
          rate
        }, index) => <ModalRateItem icon={icon as IconNames} title={title} rate={rate as number} key={'MODAL_REVIEW_RATE_ITEM_' + index} />)}
          </Box>}
        <Box className={Styles['reviews-items-container']} data-sentry-element="Box" data-sentry-source-file="ReviewsModal.tsx">
          {(loading || !reviews) && page === 1 ? <>
              <Skeleton variant={'text'} width={120} height={24} />
              <ReviewCardSkeleton isBrief={false} />
              <ReviewCardSkeleton isBrief={false} />
            </> : <>
              <Box className={Styles['reviews-items-header']}>
                <Typography component="span" variant="bodyL_Bold">
                  {totalReviews} نظر ثبت شده
                </Typography>
              </Box>
              <InfiniteScroll dataLength={reviews?.length} next={() => {
            const fetchPage = page + 1;
            setPage(fetchPage);
            dispatch(fetchProductReviews(id, fetchPage));
            handleReviewIndex && handleReviewIndex();
          }} loader={loading && page > 1 && <Box className={Styles['loading-infinite-scroll']}>
                      <Spinner color="neutral_800" />
                    </Box>} hasMore={reviews?.length < totalReviews} className={Styles['reviews-list-wrapper']} height={isMobile ? 'calc(100vh - 155px)' : 'calc(70vh - 148px)'}>
                {reviews.map((review, index) => <ReviewCard image={review?.user?.avatar_path} date={getDaysPassed(String(review?.checkout_date))} name={review?.user?.name} rate={review?.point_average} reviewContent={review?.comment} suggestStatus={Suggest?.[review?.suggest]} reply={review?.host_reply} advantages={review?.positives} disadvantages={review?.negatives} key={'REVIEWS_ITEM_INDEX_' + index} />)}
              </InfiniteScroll>
            </>}
        </Box>
      </Box>
    </Box>;
};
export default ReviewsModal;